import { render } from "./LoginMinistry.vue?vue&type=template&id=5548a843"
import script from "./LoginMinistry.vue?vue&type=script&lang=js"
export * from "./LoginMinistry.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__